import { memo } from 'react'
import { Box, Button, Title, createStyles, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { transitionStyles } from 'src/styles'
import Fade from 'react-reveal/Fade'

const useStyles = createStyles((theme, { isMobile }: { isMobile: boolean }) => ({
  contactWrapper: {
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: isMobile ? 'center' : 'flex-end',
    backgroundColor: theme.colors.white,
    gap: 18,
    marginTop: isMobile ? 30 : 0,
  },
}))

export const ContactForm = memo(() => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)
  const { classes } = useStyles({ isMobile })

  return (
    <Box className={classes.contactWrapper}>
      <Fade right>
        <Title
          order={isMobile ? 4 : 3}
          color={theme.colorScheme === 'dark' ? theme.colors.blue[4] : theme.primaryColor}
        >
          Let's connect for something great!
        </Title>
        <Button
          component="a"
          href="mailto:tirthgpatel.27@gmail.com?subject=Hey%20Tirth%2C%20I%20want%20to"
          variant="gradient"
          gradient={{ from: 'indigo', to: 'cyan' }}
          sx={theme => ({
            paddingInline: 56,
            height: 50,
            borderRadius: theme.radius.xl,
            fontSize: 16,
            '&:hover': {
              transform: 'scale(1.1)',
              // gradient: { from: 'cyan', to: 'indigo' },
              transition: transitionStyles.themeChange,
            },
          })}
        >
          Send a Message
        </Button>
      </Fade>
    </Box>
  )
})
